import { CssBaseline, FormControl, FormHelperText, Grid, TextField, MenuItem } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import useStyles from '../../CommonStyle/CommonStyle';
import { FormattedMessage } from 'react-intl';

const processOptions = [
    {
        value: 'PO Transmission',
        label: 'PO Transmission',
    },
    {
        value: 'PO(ASN) Transmission',
        label: 'PO(ASN)Transmission',
    },
];

const PoAsnCombo = (props) => {
    const classes = useStyles();
    const { comboProperty, control, errors, comboValue, setComboValue } = props;

    return (
        <React.Fragment>
            <CssBaseline />
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    {/* Controller from React Hook Form handles state, validation, and submission. */}
                    <Controller
                        name={comboProperty.name}
                        control={control}
                        rules={{ required: comboProperty.isRequired }}
                        render={({ field: { onChange } }) => (
                            // Using a TextField with the 'select' prop is the standard MUI way
                            // to create a dropdown menu that looks like a text field.
                            <TextField
                                select
                                className={classes.textField}
                                label={comboProperty.label}
                                size="small"
                                variant={comboProperty.variant}
                                required={comboProperty.isRequired}
                                error={!!_.get(comboProperty.name, errors)}
                                disabled={comboProperty.isDisabled}
                                // The component is "controlled" by the parent's state via comboValue.
                                // The `|| ''` ensures the value is never null/undefined, preventing React warnings.
                                value={comboValue || ''}
                                onChange={(event) => {
                                    const newValue = event.target.value;
                                    onChange(newValue);
                                    setComboValue(newValue);
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    classes: { asterisk: classes.asterisk }
                                }}
                            >
                                {processOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}
                    />
                    {/* This block handles displaying validation errors from React Hook Form. */}
                    <div className={classes.error}>
                        {_.get(`${comboProperty.name}.type`, errors) === 'required' && (
                            <FormHelperText className={classes.error}>
                                {comboProperty.label} <FormattedMessage id="textfield.error.isrequirededmessage" defaultMessage="is required" />
                            </FormHelperText>
                        )}
                    </div>
                </FormControl>
            </Grid>
        </React.Fragment>
    );
};

PoAsnCombo.propTypes = {
    comboProperty: PropTypes.object.isRequired,
    control: PropTypes.any.isRequired,
    errors: PropTypes.object,
    comboValue: PropTypes.string,
    setComboValue: PropTypes.func.isRequired,
    
};

export default PoAsnCombo;
